"use client";

import { memo } from "react";
import { cn } from "@/lib/utils";
import { Typography } from "@/components/ui/typography";
import type { ServicesTranslationPromptProps } from "./types";
import { servicesTranslationPromptMap } from "./constants";
import { ServicesPricingPlans } from "@/components/screen/global-components/services";

const ServicesTranslationPrompt = ({
  variant = "quality",
  className,
}: ServicesTranslationPromptProps) => {
  const {
    cards,
    content: { title, description },
  } = servicesTranslationPromptMap[variant];

  return (
    <section className={cn("section lg:bg-background-secondary", className)}>
      <div className="container mx-auto py-12 lg:py-20">
        <div className="flex flex-col justify-center gap-4 md:gap-2 md:w-full md:max-w-[800px] md:mx-auto">
          <Typography variant="heading4" className="text-center">
            <h2>{title}</h2>
          </Typography>
          <div className="flex justify-center text-gray-600">
            <Typography variant="subHeadingSm" className="text-center" asChild>
              <p>{description}</p>
            </Typography>
          </div>
        </div>
        <ServicesPricingPlans className="mt-6 lg:mt-12" cards={cards} />
      </div>
    </section>
  );
};

export default memo(ServicesTranslationPrompt);
